export var GeneralSettingsSubject;
(function (GeneralSettingsSubject) {
    GeneralSettingsSubject["GeneralSettingsPage"] = "general-settings-page";
    GeneralSettingsSubject["AccountToken"] = "account-token";
    GeneralSettingsSubject["AccountLogoUpload"] = "account-logo-upload";
    GeneralSettingsSubject["AccountLogoImage"] = "account-logo-image";
    GeneralSettingsSubject["AccountLogoDelete"] = "account-logo-delete";
    GeneralSettingsSubject["AccountLogoImageSpinner"] = "account-logo-image-spinner";
    GeneralSettingsSubject["UpdateTheme"] = "update-theme";
    GeneralSettingsSubject["UserEmail"] = "user-email";
    GeneralSettingsSubject["UserFullName"] = "user-full-name";
    GeneralSettingsSubject["AccountName"] = "account-name";
    GeneralSettingsSubject["Password"] = "password";
    GeneralSettingsSubject["PciLevel"] = "pci-level";
    GeneralSettingsSubject["RefreshKibanaMappingNotification"] = "refresh-kibana-mapping-notification";
    GeneralSettingsSubject["RefreshKibanaMappingButton"] = "refresh-kibana-mapping-button";
    GeneralSettingsSubject["SupportAccessToggle"] = "support-success-toggle";
    GeneralSettingsSubject["EnabledSupportAccess"] = "enabled-support-success";
    GeneralSettingsSubject["DisabledSupportAccess"] = "disabled-support-success";
    GeneralSettingsSubject["UpdateSupportAccessButton"] = "update-support-success-button";
    GeneralSettingsSubject["SelectSupportAccess"] = "select-support-success";
    GeneralSettingsSubject["ChangeSupportAccess"] = "change-support-access";
    GeneralSettingsSubject["LandingPageValue"] = "landing-page-current-value";
    GeneralSettingsSubject["LandingPageSelector"] = "landing-page-selector";
    GeneralSettingsSubject["LandingPageResetButton"] = "landing-page-reset-button";
    GeneralSettingsSubject["ConfirmLandingPageModal"] = "confirm-landing-page";
    GeneralSettingsSubject["LandingPageChangeNotification"] = "landing-page-notification";
    GeneralSettingsSubject["LoadingAccountSettingsSection"] = "loading-account-settings-section";
    GeneralSettingsSubject["NewAppToggle"] = "new-app-toggle";
})(GeneralSettingsSubject || (GeneralSettingsSubject = {}));
export var GeneralSettingsPasswordSubject;
(function (GeneralSettingsPasswordSubject) {
    GeneralSettingsPasswordSubject["New"] = "new-password-input";
    GeneralSettingsPasswordSubject["Current"] = "current-password-input";
    GeneralSettingsPasswordSubject["ChangeButton"] = "change-password-button";
    GeneralSettingsPasswordSubject["UpdateButton"] = "update-password-button";
    GeneralSettingsPasswordSubject["NotificationUpdateSuccess"] = "update-success-notification";
    GeneralSettingsPasswordSubject["NotificationUpdateFailed"] = "update-failure-notification";
    GeneralSettingsPasswordSubject["Cancel"] = "cancel-button";
})(GeneralSettingsPasswordSubject || (GeneralSettingsPasswordSubject = {}));
export var GeneralSettingsSectionsSubject;
(function (GeneralSettingsSectionsSubject) {
    GeneralSettingsSectionsSubject["User"] = "user-section";
    GeneralSettingsSectionsSubject["Account"] = "account-section";
})(GeneralSettingsSectionsSubject || (GeneralSettingsSectionsSubject = {}));
export var GeneralSettingsPciStatus;
(function (GeneralSettingsPciStatus) {
    GeneralSettingsPciStatus["Initial"] = "INITIAL";
    GeneralSettingsPciStatus["PendingActivation"] = "PENDING_ACTIVATE";
    GeneralSettingsPciStatus["Activated"] = "ACTIVATED";
    GeneralSettingsPciStatus["PendingDeactivation"] = "PENDING_DEACTIVATE";
    GeneralSettingsPciStatus["Deactivated"] = "DEACTIVATED";
})(GeneralSettingsPciStatus || (GeneralSettingsPciStatus = {}));
export var GeneralSettingsPciSubject;
(function (GeneralSettingsPciSubject) {
    GeneralSettingsPciSubject["Button"] = "activate-button";
    GeneralSettingsPciSubject["ConfirmModal"] = "pci-confirm-modal";
    GeneralSettingsPciSubject["Checkbox"] = "pci-checkbox";
    GeneralSettingsPciSubject["ActivationSent"] = "pci-text";
    GeneralSettingsPciSubject["Row"] = "pci-row";
    GeneralSettingsPciSubject["RequestSentNotification"] = "request-sent-notification";
    GeneralSettingsPciSubject["OpensearchDashboards"] = "opensearch-dashboards";
})(GeneralSettingsPciSubject || (GeneralSettingsPciSubject = {}));
//# sourceMappingURL=general-settings.enum.js.map